export default "__VITE_ASSET__wuZMnciu__"